import React from 'react';
import { Button, Box, Section } from '@common/components';
import { Row, Col, Typography } from 'antd';
import { DeleteFilled, EditFilled } from '@ant-design/icons';

const CellGroup = ({ cellGroup, onClick, onEdit, onDelete }) => {
	return (
		<Box className="p-3">
			<Section className="mb-3" hoverable shadowed>
				<Row
					type="flex"
					className="login-links"
					onClick={() => onClick && onClick(cellGroup)}>
					<Col>
						<Typography.Title level={3}>
							{cellGroup.title}
						</Typography.Title>
						<Typography.Text level={3}>
							{cellGroup.description}
						</Typography.Text>
					</Col>
				</Row>
				<Box textAlign="right">
					{onEdit && (
						<Button
							size="small"
							type="text"
							onClick={() => onEdit && onEdit(cellGroup)}>
							<EditFilled style={{ color: '#FFCC00' }} />
						</Button>
					)}
					{onDelete && (
						<Button
							size="small"
							type="text"
							onClick={() => onDelete && onDelete(cellGroup)}>
							<DeleteFilled style={{ color: '#FF0000' }} />
						</Button>
					)}
				</Box>
			</Section>
		</Box>
	);
};

export default CellGroup;
